import { render, staticRenderFns } from "./ChangeCorralModal.vue?vue&type=template&id=fa040b7a"
import script from "./ChangeCorralModal.vue?vue&type=script&lang=js"
export * from "./ChangeCorralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports